import { TMessageSchema, TOutcomingStatus, IParsedMessage, TMessagesMap } from '../../types/messages';
import { parseMessage } from './parseMessage';
import { updateExistingMessage } from './updateExistingMessage';
import { updateMessageIndexInMap } from './updateMessageIndexInMap';

interface IApplyRawMessagesToChatParams {
  messagesMap: TMessagesMap;
  rawMessages: TMessageSchema[];
  chatMessages: IParsedMessage[];
  userId: number;
  status?: TOutcomingStatus;
  checkRowVersion?: boolean;
}

/** Применяет сырые сообщения к чату, обновляя карту сообщений при изменении индексов. */
export function updateMessagesInChat({
  messagesMap,
  rawMessages,
  chatMessages,
  userId,
  status,
  checkRowVersion,
}: IApplyRawMessagesToChatParams): IParsedMessage[] {
  // Копируем чат один раз, дальше работаем с этой копией
  const nextChatMessages = [...chatMessages];

  rawMessages.forEach(rawMessage => {
    const messageItem = messagesMap.get(rawMessage.messageId);

    // Сценарий 1: Сообщение уже существует (обновление)
    if (messageItem) {
      const { message, messageIndex } = messageItem;

      // обновляем только если обновился rowVersion
      if (!!checkRowVersion && message.message.rowVersion === rawMessage.rowVersion) {
        return;
      }

      const parsedMessage = updateExistingMessage({
        messageItem,
        rawMessage,
        messagesMap,
      });

      if (nextChatMessages[messageIndex]) {
        nextChatMessages[messageIndex] = parsedMessage;
      }

      return;
    }

    // Сценарий 2: Новое сообщение (добавление)
    const parsedMessage = parseMessage({ rawMessage, userId, status });

    nextChatMessages.push(parsedMessage);
  });

  // Если длина изменилась, значит, добавились новые сообщения
  if (nextChatMessages.length !== chatMessages.length) {
    updateMessageIndexInMap({ chatMessages: nextChatMessages, messagesMap });
  }

  return nextChatMessages;
}
